import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Profile from "../assets/profile.webp";
import { Box, Divider } from "@mui/material";
import { AiFillGithub } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";
import { FiFigma } from "react-icons/fi";
import { BsLinkedin } from "react-icons/bs";
import { CgNotes } from "react-icons/cg";
import { BiLogoFigma } from "react-icons/bi";
import { GrReactjs } from "react-icons/gr";
import { BiLogoJavascript } from "react-icons/bi";
import { BiLogoPostgresql } from "react-icons/bi";
import { FaPython } from "react-icons/fa";
import { BiLogoCss3 } from "react-icons/bi";
import { BiLogoVuejs } from "react-icons/bi";
import { BiLogoFlask } from "react-icons/bi";
import { SiMui } from "react-icons/si";
import { FaGitlab } from "react-icons/fa6";

export default function Hero() {
  const theme = useTheme();
  return (
    <>
      <Box className="profile-section" sx={{ width: "92%", margin: "0 auto" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <img src={Profile} alt="Joshua Profile Pic" />
          <Box
            className="open-to-work_btn"
            variant="body1"
            sx={{
              color: "rgb(3, 226, 107)",
              fontSize: "16px",
              fontWeight: 200,
              background: "rgba(3, 226, 107,0.04)",
              padding: "8px 20px",
              cursor: "pointer",
              borderRadius: "3px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "8px",
                height: "8px",
                background: theme.palette.common.green,
                marginRight: "10px",
                borderRadius: "50%",
              }}
            ></Box>
            <Box>Open to Work</Box>
          </Box>
        </Box>
        <Typography
          variant="h1"
          sx={{
            color: theme.palette.common.white,
            marginTop: "26px",
            letterSpacing: "1px",
            lineHeight: "58px",
            width: "80%",
          }}
        >
          Hey, I'm Joshua - I'm a Fullstack Software Engineer & Designer
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "rgb(128, 128, 128)",
            fontSize: "16px",
            fontWeight: 200,
            marginTop: "15px",
          }}
        >
          I'm the digital maestro behind the screen, a full-stack web developer
          with a passion for turning lines of code into stunning online
          experiences. With an insatiable curiosity for all things tech, I
          thrive on solving digital puzzles and bringing creative visions to
          life. Whether it's front-end finesse or back-end wizardry,I'm your
          go-to developer for turning your web dreams into reality.
        </Typography>

        <Box className="socials" sx={{ marginTop: "19px" }}>
          <AiFillGithub />
          <AiOutlineInstagram />
          <FiFigma />
          <BsLinkedin />
          <CgNotes />
        </Box>
      </Box>
      <Divider sx={{ borderColor: "rgb(41, 41, 41);", marginTop: "24px" }} />
      <Box className="slider">
        <BiLogoFigma />
        <GrReactjs />
        <BiLogoVuejs />
        <BiLogoJavascript />
        <BiLogoPostgresql />
        <FaPython />
        <BiLogoCss3 />
        <BiLogoFlask />
        <SiMui />
        <FaGitlab />
        <AiFillGithub />
      </Box>
      <Divider sx={{ borderColor: "rgb(41, 41, 41);" }} />
    </>
  );
}
